import type { ID, ReduxAction } from '@repo/utils/types';
import AppState from '../app-state';
import Occasion from '@repo/utils/helpers/Occasion';
import Collection from '@repo/utils/models/Collection';
import { SharedGroup } from '@repo/utils/models/SharedGroup';

export type SharedGroupsState = Collection<SharedGroup>;
const initialSharedGroupState = new Collection<SharedGroup>();

export const selectSharedGroup = (uuid: ID) => (state: AppState) =>
  state.sharedData.groups.items.get(uuid, new SharedGroup());

export function sharedGroupsReducer(
  state: SharedGroupsState = initialSharedGroupState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_SHARED_GROUP_SUCCEEDED':
      return state.copyWith({
        items: state.items.update(
          payload.groupUUID,
          new SharedGroup({ ...payload, updated: new Occasion() }),
          (sharedGroup) => sharedGroup.copyWith({ ...payload, updated: new Occasion() }),
        ),
      });

    case 'FETCH_SHARED_GROUP_FAILED':
      return state.copyWith({
        items: state.items.update(
          payload.groupUUID,
          new SharedGroup({ error: payload.error }),
          (sharedGroup) => sharedGroup.copyWith({ error: payload.error }),
        ),
      });

    default:
      return state;
  }
}
